import ApiBase from './base/ApiBase';

export type AiVoiceWorkflow = 'PositionDescription' | 'TemplateCreation' | 'EmployeeReview';

export interface AiVoiceSessionRequest {
    Workflow: AiVoiceWorkflow;
    ContextId?: string | null;
}

export interface AiVoiceSessionResponse {
    Available: boolean;
    SessionId?: string | null;
    ClientSecret?: string | null;
    ExpiresAt?: number | null;
    CallsUrl?: string | null;
    UnavailableReason?: string | null;
}

class AiVoiceClient extends ApiBase {
    async CreateSession(request: AiVoiceSessionRequest, signal?: AbortSignal): Promise<AiVoiceSessionResponse> {
        return this.PostAsync('AiVoice/Session', request, signal);
    }
}

export default AiVoiceClient;
